import { Routes } from '@angular/router';
import { languageResolver } from '../landing/guards/language.guards';

export const landingRoutes: Routes = [
  {
    path: 'home',
    resolve: { isLandingPageEnabled: languageResolver },
    loadComponent: () =>
      import('./landing-layout.component').then(m => m.LandingLayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('../pages/landing/home/landing-home.component').then(
            m => m.LandingHomeComponent
          ),
      },
    ],
  },
  {
    path: 'landing',
    loadComponent: () =>
      import('./landing-layout.component').then(m => m.LandingLayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('../pages/landing/home/landing-home.component').then(
            m => m.LandingHomeComponent
          ),
      },
    ],
  },
];
